export default {
    "stage_date_end_included": false,
    "is_required_stage_dates": true,
    "types": {
        "plan": {
            "showName": "Постановка KPI",
            "selected": false,
            "order": 1,
            "autostart": false,
            "canManageElementsBeforeDateStart": false,
            "canManageElementsAfterDateEnd": false,
            "hideDates": false,
            "showNegotiationsDates": true
        },
        "correction": {
            "showName": "Корректировка KPI",
            "selected": false,
            "order": 2,
            "canManageElementsBeforeDateStart": false,
            "canManageElementsAfterDateEnd": false,
            "canBeAddedDynamically": true,
            "hideDates": false,
            "showNegotiationsDates": true
        },
        "intermediate_assessment": {
            "showName": "Промежуточная оценка",
            "selected": false,
            "order": 3,
            "canManageElementsBeforeDateStart": false,
            "canManageElementsAfterDateEnd": false,
            "hideDates": false,
            "showNegotiationsDates": true
        },
        "assessment": {
            "showName": "Подведение итогов",
            "selected": false,
            "order": 4,
            "canManageElementsBeforeDateStart": false,
            "canManageElementsAfterDateEnd": false,
            "hideDates": false,
            "showNegotiationsDates": true
        }
    }
}